import ApiService from "@/core/services/ApiService";
import { Actions, APIEndpoints } from "@/store/enums/StoreEnums";
import { Module, Action, VuexModule, config } from "vuex-module-decorators";

config.rawError = true;

@Module
export default class AvailableJobModule extends VuexModule {
  @Action
  [Actions.GET_COUNTRIES]() {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(`${APIEndpoints.COUNTRY}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
